import api from '@/libs/axios'

export default {
  async getList(params) {
    let response = await api.get('/admin/sale-popups', {
      params,
    })
    return response
  },
  async update(payload) {
    let response = await api.put('/admin/sale-popups', payload)
    return response
  },
  async create(payload) {
    const response = await api.post('/admin/sale-popups', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/sale-popups', {
      data: payload,
    })
    return response
  },
}
